import "./Button.scss";

// Possible colors are : green, red, lightgreen, white, whitered
// Show button : true or false
// Func = function when click on button
function Button({ color, text, show, func }) {
  return (
    <div
      className={show === true ? `button ${color}` : `button ${color} hidden`}
      onClick={func}
    >
      {text}
    </div>
  );
}

export default Button;
